<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CustomerProfile.customerProfile')"/>
        </div>
    </div>
</template>

<script>
import PageTitle from "../../shared/misc/PageTitle";
export default {
    name: "CustomerProfile",
    components: {PageTitle},
    props: {
        customers: {
            required: true,
        },
    },
    watch: {
        $allCustomersSelected(value) {
            if (value === true) {
                return this.$router.push("/crm/customers");
            }
        },
    },
};
</script>

<style scoped>

</style>